export default function Second() {
  return (
    <>
      <g>
        <path
          d="M 214.86087,108.11373 214.95371,8.912589 5,169.5 c 0,0 -7.49986,3.5 -1.99993,15.5 5.49993,12 15.00003,6.5 15.00003,6.5 z"
          fill="url(#paint0_linear_527_11)"
          fillOpacity="0.9"
        />
      </g>
      <defs id="defs2">
        <linearGradient
          id="paint0_linear_527_11"
          x1="4.01539"
          y1="181.565"
          x2="191.545"
          y2="24.1227"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE32B" />
          <stop offset="1" stopColor="#B60C00" />
        </linearGradient>
      </defs>
    </>
  );
}
